function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#66CEEF;}\n\t.st1{fill:#1A87C7;}\n\t.st2{fill:#BDEDF8;}\n");

var _ref3 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("polygon", {
  className: "st0",
  points: "693,657.6 693,627 666.6,642.3  "
}), React.createElement("path", {
  className: "st1",
  d: "M693,663.5l-31.6-18.2l-5,2.9l39.2,22.8c-1.3-0.9-2.6-2.6-2.6-4.5V663.5z"
}), React.createElement("path", {
  className: "st1",
  d: "M695.6,671c0.9,0.4,1.8,0.7,2.6,0.7c0.9,0,1.8-0.3,2.6-0.7C699.1,671.9,697.3,671.9,695.6,671z"
}), React.createElement("polygon", {
  className: "st1",
  points: "666.6,642.3 661.4,645.3 693,663.5 693,657.6  "
}), React.createElement("polygon", {
  className: "st0",
  points: "693,201.4 654.9,179.3 654.9,207.9 665.8,214.3 693,230  "
}), React.createElement("path", {
  className: "st1",
  d: "M649.6,205.8v-29.7l-2.2-1.3c-1.8-0.9-2.6-2.6-2.6-4.5V208l2.6-1.5C648,206,648.8,205.9,649.6,205.8z"
}), React.createElement("path", {
  className: "st1",
  d: "M652.3,206.5l13.5,7.8l-10.9-6.3v-28.7l38.1,22.1v0l-43.3-25.2v29.7C650.6,205.8,651.5,206,652.3,206.5z"
}), React.createElement("path", {
  className: "st0",
  d: "M379.6,385.5V417l80.2-46.3l228.1-131.8l-15.2-8.8l-23.1-13.2L371.3,377.7l5.7,3.3 C378.7,382,379.6,383.7,379.6,385.5z"
}), React.createElement("polygon", {
  className: "st0",
  points: "688,238.8 672.7,230.1 687.9,238.9  "
}), React.createElement("path", {
  className: "st1",
  d: "M645.4,213.3c-0.4-0.7-0.6-1.6-0.6-2.4V208L360.9,371.8l5.1,3L645.4,213.3z"
}), React.createElement("polygon", {
  className: "st1",
  points: "665.8,214.3 693,230 693,230  "
}), React.createElement("path", {
  className: "st1",
  d: "M645.4,213.3l4.2-2.4v-5.1c-0.8,0-1.6,0.2-2.2,0.6l-2.6,1.5v2.9C644.8,211.8,645.1,212.6,645.4,213.3z"
}), React.createElement("path", {
  className: "st1",
  d: "M693,230l-27.2-15.8l-13.5-7.8c-0.7-0.5-1.7-0.7-2.6-0.6v5.1l43.3,25V230z"
}), React.createElement("polygon", {
  className: "st1",
  points: "459.8,370.7 379.6,417 379.6,417.1  "
}), React.createElement("path", {
  className: "st1",
  d: "M649.6,216.9l23.1,13.2l-25.3-14.7c-0.9-0.5-1.6-1.2-2-2L366,374.7l5.2,3L649.6,216.9z"
}), React.createElement("path", {
  className: "st1",
  d: "M647.5,215.4l25.3,14.7l15.3,8.8l4.9-2.9v-0.1l-43.3-25l-4.2,2.4C645.9,214.2,646.5,214.9,647.5,215.4z"
}), React.createElement("polygon", {
  className: "st0",
  points: "719.6,180.2 795.4,136.5 756.9,114.4 660.1,170.4 689.4,187.4 698.2,192.5  "
}), React.createElement("polygon", {
  className: "st0",
  points: "689.4,187.4 698.2,192.5 698.2,192.5  "
}), React.createElement("path", {
  className: "st1",
  d: "M652.3,165.9l2.5,1.5l102.1-59l43.8,25.1l2.6-1.5c1.3-0.9,3.5-0.9,4.8,0l-48.6-28c-1.3-0.9-3.5-0.9-4.8,0 l-107.2,61.9C648.8,165,651,165,652.3,165.9z"
}), React.createElement("path", {
  className: "st1",
  d: "M647.5,174.8l2.2,1.3v-5.7l5.2-3l-2.5-1.5c-1.3-0.9-3.5-0.9-4.8,0c-1.8,0.9-2.6,2.6-2.6,4.5 C644.8,172.2,645.7,173.9,647.5,174.8z"
}), React.createElement("path", {
  className: "st1",
  d: "M693,198.4c0-0.9,0.3-1.8,0.8-2.6l-44.1-25.5v5.7l43.3,25.2V198.4z"
}), React.createElement("polygon", {
  className: "st1",
  points: "660.1,170.4 756.9,114.4 795.4,136.5 719.6,180.2 800.7,133.5 756.9,108.4 654.8,167.4 689.4,187.4  "
}), React.createElement("path", {
  className: "st1",
  d: "M695.6,194l2.6-1.5l-8.8-5.1l-34.6-20l-5.2,3l44.1,25.5C694.3,195.1,694.9,194.4,695.6,194z"
}), React.createElement("path", {
  className: "st2",
  d: "M700.8,243.4L377,430.5c-0.9,0.4-1.7,0.7-2.6,0.7c-0.9,0-1.7-0.3-2.6-0.7l-32.5-18.8l-41.7,24.1l-25.2,14.6 v456.2l96.7-56v-45.4c0-1.9,0.9-3.6,2.6-4.5L646.5,642c-1-1-1.6-2.1-1.6-3.5v-21L386.2,766.9c-0.9,0.5-1.7,0.7-2.6,0.7 c-0.9,0-1.8-0.2-2.6-0.7c-1.3-0.9-2.6-2.6-2.6-4.4V458c0-1.8,1.3-3.5,2.6-4.5l303.3-175c1.7-0.9,3.5-0.9,4.8,0 c1.8,1,2.6,2.6,2.6,4.5v304.5c0,1.8-0.9,3.5-2.6,4.5l-12.9,7.4l24.7,14.2c1.7,0.9,2.6,2.6,2.6,4.5v39.5l97.2-56V145.4l-97.2,56 v37.5C703.5,240.8,702.6,242.5,700.8,243.4z M353.4,802.7c0,9.6-6.6,20.8-14.9,25.6l-31.1,17.9c-2.6,1.6-5.2,2.4-7.9,2.4 c-2.2,0-3.9-0.5-5.7-1.5c-3.9-2.2-6.1-6.7-6.1-12.4v-28.3c0-9.6,6.1-20.8,14.4-25.6l31.1-17.9c4.8-2.8,10.1-3.1,14-0.8 c3.9,2.2,6.1,6.8,6.1,12.4V802.7z M353.4,696.1c0,9.6-6.6,20.9-14.9,25.6l-31.1,17.9c-2.6,1.6-5.2,2.4-7.9,2.4 c-2.2,0-3.9-0.5-5.7-1.5c-3.9-2.3-6.1-6.8-6.1-12.4v-28.2c0-9.6,6.1-20.9,14.4-25.6l31.1-17.9c4.8-2.8,10.1-3.1,14-0.9 c3.9,2.3,6.1,6.8,6.1,12.4V696.1z M353.4,589.5c0,9.6-6.6,20.8-14.9,25.6L307.4,633c-2.6,1.6-5.2,2.4-7.9,2.4 c-2.2,0-3.9-0.5-5.7-1.5c-3.9-2.3-6.1-6.8-6.1-12.4v-28.3c0-9.6,6.1-20.8,14.4-25.6l31.1-17.9c4.8-2.8,10.1-3.1,14-0.9 c3.9,2.3,6.1,6.8,6.1,12.4V589.5z M353.4,482.9c0,9.6-6.6,20.8-14.9,25.7l-31.1,17.9c-2.6,1.6-5.2,2.4-7.9,2.4 c-2.2,0-3.9-0.5-5.7-1.5c-3.9-2.3-6.1-6.8-6.1-12.4v-28.2c0-9.6,6.1-20.9,14.4-25.7l31.1-17.9c4.8-2.8,10.1-3.1,14-0.9 c3.9,2.3,6.1,6.8,6.1,12.4V482.9z M718.8,237.7c0-9.6,6.6-20.9,14.9-25.6l31.1-17.9c4.8-2.8,9.6-3.1,13.6-0.8 c3.9,2.2,6.1,6.7,6.1,12.4v28.3c0,9.6-6.6,20.8-14.4,25.7l-31.1,17.9c-2.6,1.6-5.7,2.4-8.3,2.4c-1.7,0-3.9-0.5-5.7-1.5 c-3.9-2.2-6.1-6.8-6.1-12.4V237.7z M718.8,344.3c0-9.6,6.6-20.9,14.9-25.6l31.1-17.9c4.8-2.8,9.6-3.1,13.6-0.9 c3.9,2.3,6.1,6.8,6.1,12.4v28.3c0,9.6-6.6,20.9-14.4,25.6L738.9,384c-2.6,1.5-5.7,2.3-8.3,2.3c-1.7,0-3.9-0.5-5.7-1.5 c-3.9-2.2-6.1-6.7-6.1-12.3V344.3z M718.8,450.9c0-9.6,6.6-20.9,14.9-25.6l31.1-17.9c4.8-2.8,9.6-3.1,13.6-0.9 c3.9,2.3,6.1,6.8,6.1,12.4v28.3c0,9.6-6.6,20.9-14.4,25.6l-31.1,17.9c-2.6,1.5-5.7,2.3-8.3,2.3c-1.7,0-3.9-0.5-5.7-1.5 c-3.9-2.3-6.1-6.8-6.1-12.4V450.9z M718.8,557.5c0-9.6,6.6-20.9,14.9-25.7l31.1-17.9c4.8-2.7,9.6-3.1,13.6-0.8 c3.9,2.2,6.1,6.7,6.1,12.4v28.2c0,9.6-6.6,20.8-14.4,25.6l-31.1,17.9c-2.6,1.6-5.7,2.3-8.3,2.3c-1.7,0-3.9-0.5-5.7-1.5 c-3.9-2.3-6.1-6.7-6.1-12.3V557.5z"
}), React.createElement("polygon", {
  className: "st2",
  points: "665.9,605.4 654.9,611.7 654.9,635.5 656.3,636.3 687.9,618.1  "
}), React.createElement("path", {
  className: "st2",
  d: "M649.6,614.7l-4.8,2.8v21c0,1.4,0.7,2.6,1.6,3.5l4.6-2.7l-1.5-0.8V614.7z"
}), React.createElement("path", {
  className: "st2",
  d: "M671,602.4l22,12.7l2.6-1.5c1.8-0.9,3.5-0.9,5.3,0l-24.7-14.2L671,602.4z"
}), React.createElement("polygon", {
  className: "st2",
  points: "665.9,605.4 687.9,618.1 693,615.1 671,602.4  "
}), React.createElement("polygon", {
  className: "st2",
  points: "654.9,611.7 649.6,614.7 649.6,638.5 651.1,639.3 656.3,636.3 654.9,635.5  "
}), React.createElement("polygon", {
  className: "st2",
  points: "369.1,417 369.1,394.5 349.6,405.7  "
}), React.createElement("path", {
  className: "st2",
  d: "M371.7,430.5c0.9,0.4,1.8,0.7,2.6,0.7c0.9,0,1.7-0.3,2.6-0.7C375.2,431.4,373.5,431.4,371.7,430.5z"
}), React.createElement("path", {
  className: "st2",
  d: "M369.1,426v-3l-24.7-14.3l-5.2,3l32.5,18.8C370,429.6,369.1,427.9,369.1,426z"
}), React.createElement("polygon", {
  className: "st2",
  points: "349.6,405.7 344.4,408.7 369.1,423 369.1,417  "
}), React.createElement("path", {
  className: "st1",
  d: "M808.1,140.9l-2.2,1.3v462.4l-102.4,58.9v3c0,1.8-0.9,3.5-2.6,4.5l107.2-62c1.7-0.9,2.6-2.6,2.6-4.4V136.5 C810.7,138.3,809.8,140,808.1,140.9z"
}), React.createElement("path", {
  className: "st1",
  d: "M374.4,805.2v48.4l-102,58.9v3c0,1.8-1.3,3.5-2.6,4.5L377,858c1.8-0.9,2.6-2.6,2.6-4.5v-45.4l276.8-160l-5.1-3 L374.4,805.2z"
}), React.createElement("polygon", {
  className: "st1",
  points: "666.6,642.3 693,627 693,621.1 661.5,639.3  "
}), React.createElement("path", {
  className: "st1",
  d: "M703.5,666.5v-3l-5.3,3l-5.3-3v3c0,1.8,1.3,3.5,2.6,4.5c1.8,0.9,3.5,0.9,5.3,0 C702.6,670.1,703.5,668.3,703.5,666.5z"
}), React.createElement("polygon", {
  className: "st1",
  points: "656.3,642.3 651.3,645.2 656.4,648.2 661.4,645.3  "
}), React.createElement("polygon", {
  className: "st1",
  points: "693,621.1 693,627 693,657.6 693,663.5 698.2,666.5 698.2,618.1  "
}), React.createElement("polygon", {
  className: "st1",
  points: "661.5,639.3 656.3,642.3 661.4,645.3 666.6,642.3  "
}), React.createElement("path", {
  className: "st1",
  d: "M698.2,233v-29.4c-0.9,0-1.8-0.2-2.6-0.7l-2.6-1.5v0V230L698.2,233z"
}), React.createElement("polygon", {
  className: "st1",
  points: "687.9,238.9 459.8,370.7 688,239  "
}), React.createElement("path", {
  className: "st1",
  d: "M377,389.9l-2.6,1.5v28.7l5.3-3v-31.6C379.6,387.3,378.7,389,377,389.9z"
}), React.createElement("polygon", {
  className: "st1",
  points: "688,239 688.2,238.9 688,238.8 687.9,238.9  "
}), React.createElement("polygon", {
  className: "st1",
  points: "698.2,233 693,230 693,230 693,235.9 698.2,238.9  "
}), React.createElement("polygon", {
  className: "st1",
  points: "374.4,426 693,241.9 688,239 459.8,370.7 379.6,417.1 379.6,417 374.4,420.1  "
}), React.createElement("polygon", {
  className: "st1",
  points: "688,239 693,241.9 698.2,238.9 693,235.9 693,236 688,238.8 688.2,238.9  "
}), React.createElement("polygon", {
  className: "st1",
  points: "698.2,192.5 719.6,180.2 698.2,192.5  "
}), React.createElement("polygon", {
  className: "st1",
  points: "698.2,192.5 698.2,192.5 698.2,192.5 698.2,192.5  "
}), React.createElement("path", {
  className: "st1",
  d: "M803.3,132l-2.6,1.5l5.2,3v5.7l2.2-1.3c1.7-1,2.6-2.6,2.6-4.5c0-1.8-0.9-3.5-2.6-4.5 C806.8,131.1,804.6,131.1,803.3,132z"
}), React.createElement("path", {
  className: "st1",
  d: "M698.2,203.6v-5.2l-4.4-2.6c-0.5,0.8-0.8,1.6-0.8,2.6v2.9l2.6,1.5C696.5,203.4,697.3,203.6,698.2,203.6z"
}), React.createElement("path", {
  className: "st1",
  d: "M698.2,192.5l2.6,1.5c0.9,0.4,1.5,1.1,1.9,1.8l103.1-59.3l-5.2-3l-81.1,46.7L698.2,192.5z"
}), React.createElement("path", {
  className: "st1",
  d: "M702.8,195.8c-0.4-0.7-1.1-1.4-1.9-1.8l-2.6-1.5l0,0l0,0l-2.6,1.5c-0.7,0.4-1.3,1.1-1.8,1.9l4.4,2.6 L702.8,195.8z"
}), React.createElement("path", {
  className: "st1",
  d: "M646.5,642L371.7,800.7c-1.7,0.9-2.6,2.6-2.6,4.5v45.4l-96.7,56v5.9l102-58.9v-48.4l277-160l-3.9-2.2 C647,642.7,646.8,642.3,646.5,642z"
}), React.createElement("polygon", {
  className: "st1",
  points: "703.5,201.4 800.6,145.4 800.6,601.6 703.5,657.6 703.5,663.5 805.9,604.6 805.9,142.2 703.5,201.4  "
}), React.createElement("polygon", {
  className: "st1",
  points: "272.4,450.4 272.4,450.4 297.6,435.8  "
}), React.createElement("polygon", {
  className: "st1",
  points: "687.9,618.1 656.3,636.3 661.5,639.3 693,621.1 693,621.1  "
}), React.createElement("path", {
  className: "st1",
  d: "M703.5,618.1c0-1.8-0.9-3.5-2.6-4.5c-1.7-0.9-3.5-0.9-5.3,0l-2.6,1.5l5.2,3v48.4l5.3-3v-5.9V618.1z"
}), React.createElement("path", {
  className: "st1",
  d: "M646.5,642c0.3,0.3,0.5,0.7,1,0.9l3.9,2.2l5-2.9l-5.2-3L646.5,642z"
}), React.createElement("polygon", {
  className: "st1",
  points: "693,621.1 693,621.1 698.2,618.1 693,615.1 687.9,618.1  "
}), React.createElement("polygon", {
  className: "st1",
  points: "656.3,636.3 651.1,639.3 656.3,642.3 661.5,639.3  "
}), React.createElement("path", {
  className: "st1",
  d: "M698.2,203.6V233l2.6,1.5c1.7,0.9,2.6,2.6,2.6,4.4v-37.5v0l-2.6,1.5C700,203.4,699.1,203.6,698.2,203.6z"
}), React.createElement("polygon", {
  className: "st1",
  points: "369.1,417 374.4,420.1 374.4,391.4 369.1,394.5  "
}), React.createElement("path", {
  className: "st1",
  d: "M369.1,423v3c0,1.8,0.9,3.5,2.6,4.5c1.8,0.9,3.5,0.9,5.3,0l323.9-187.1c-0.9,0.5-1.7,0.7-2.6,0.7 c-0.9,0-1.8-0.2-2.6-0.7l-2.5-1.5L374.4,426L369.1,423z"
}), React.createElement("path", {
  className: "st1",
  d: "M698.2,244.1c0.9,0,1.8-0.2,2.6-0.7c1.7-0.9,2.6-2.6,2.6-4.5c0-1.8-0.9-3.6-2.6-4.4l-2.6-1.5v5.9l-5.2,3 l2.5,1.5C696.5,243.9,697.3,244.1,698.2,244.1z"
}), React.createElement("polygon", {
  className: "st1",
  points: "369.1,423 374.4,426 374.4,420.1 369.1,417  "
}), React.createElement("path", {
  className: "st1",
  d: "M703.5,198.4v3l102.4-59.1v-5.7l-103.1,59.3C703.2,196.6,703.5,197.5,703.5,198.4z"
}), React.createElement("path", {
  className: "st1",
  d: "M698.2,203.6c0.9,0,1.8-0.2,2.6-0.7l2.6-1.5v-3c0-0.9-0.2-1.8-0.7-2.6l-4.6,2.6V203.6z"
}), React.createElement("path", {
  className: "st1",
  d: "M383.6,762.5V458l303.3-175v304.5l-15.6,9l5,2.9L689,592c1.8-0.9,2.6-2.6,2.6-4.5V283c0-1.8-0.9-3.5-2.6-4.5 c-1.3-0.9-3.1-0.9-4.8,0l-303.3,175c-1.3,0.9-2.6,2.6-2.6,4.5v304.5c0,1.8,1.3,3.5,2.6,4.4c0.9,0.5,1.8,0.7,2.6,0.7 c0.9,0,1.7-0.2,2.6-0.7l258.6-149.4v-5.8L383.6,762.5z"
}), React.createElement("polygon", {
  className: "st1",
  points: "654.9,606 654.9,611.7 665.9,605.4 660.9,602.5  "
}), React.createElement("polygon", {
  className: "st1",
  points: "666,599.5 671,602.4 676.2,599.4 671.2,596.5  "
}), React.createElement("polygon", {
  className: "st1",
  points: "649.6,609 644.8,611.8 644.8,617.5 649.6,614.7  "
}), React.createElement("polygon", {
  className: "st1",
  points: "660.9,602.5 665.9,605.4 671,602.4 666,599.5  "
}), React.createElement("polygon", {
  className: "st1",
  points: "649.6,609 649.6,614.7 654.9,611.7 654.9,606  "
}), React.createElement("polygon", {
  className: "st1",
  points: "388.8,753.6 388.8,461 681.6,291.9 681.6,584.5 666,593.5 671.2,596.5 686.8,587.5 686.8,283  383.6,458 383.6,762.5 644.8,611.8 644.8,605.8  "
}), React.createElement("polygon", {
  className: "st1",
  points: "654.9,600 654.9,606 660.9,602.5 655.7,599.5  "
}), React.createElement("polygon", {
  className: "st1",
  points: "660.8,596.5 666,599.5 671.2,596.5 666,593.5  "
}), React.createElement("polygon", {
  className: "st1",
  points: "644.8,605.8 644.8,611.8 649.6,609 649.6,603  "
}), React.createElement("polygon", {
  className: "st1",
  points: "654.9,600 649.6,603 649.6,609 654.9,606  "
}), React.createElement("polygon", {
  className: "st1",
  points: "655.7,599.5 660.9,602.5 666,599.5 660.8,596.5  "
}), React.createElement("polygon", {
  className: "st0",
  points: "464.1,464.7 464.1,660.5 635.6,463.2  "
}), React.createElement("path", {
  className: "st1",
  d: "M651.8,455.9c-0.9-1.9-3.1-2.8-4.4-3l-188.6,1.6c-3.1,0-5.3,2.3-5.3,5.1v214.6c0,2.1,1.3,4.1,3.5,4.8 c0.4,0.2,0.9,0.4,1.7,0.4c1.3,0,2.6-0.7,3.9-1.8l188.6-216.1C652.7,459.8,652.7,457.7,651.8,455.9z M458.8,674.2V459.6l188.6-1.5 L458.8,674.2z"
}), React.createElement("path", {
  className: "st1",
  d: "M458.8,674.2L647.5,458l-188.6,1.5V674.2z M464.1,464.7l171.6-1.4L464.1,660.5V464.7z"
}), React.createElement("path", {
  className: "st0",
  d: "M733.7,588.4l31.1-17.9c5.2-3,9.6-10.8,9.6-16.7v-28.2c0-2-0.4-3.2-0.9-3.5c-0.4-0.1-0.4-0.1-0.9-0.1 c-0.4,0-1.8,0.3-2.6,1l-31.1,17.9c-5.3,3-9.6,10.8-9.6,16.8v28.2c0,2,0.4,3.1,0.9,3.4C730.6,589.5,731.9,589.4,733.7,588.4z"
}), React.createElement("path", {
  className: "st1",
  d: "M730.6,599.6c2.6,0,5.7-0.8,8.3-2.3l31.1-17.9c7.9-4.8,14.4-16.1,14.4-25.6v-28.2c0-5.6-2.2-10.1-6.1-12.4 c-3.9-2.3-8.7-1.9-13.6,0.8l-31.1,17.9c-8.3,4.8-14.9,16.1-14.9,25.7v28.2c0,5.6,2.2,10.1,6.1,12.3 C726.7,599.1,728.9,599.6,730.6,599.6z M724,557.5c0-7.8,5.2-17.3,12.3-21.2c10.5-5.9,20.6-11.9,31.1-17.9 c6.6-3.9,12.2-0.7,12.2,7.1v28.2c0,7.8-5.7,17.3-12.2,21.2l-31.1,17.9c-7,3.9-12.3,0.7-12.3-7V557.5z"
}), React.createElement("path", {
  className: "st1",
  d: "M736.3,592.8l31.1-17.9c6.6-3.9,12.2-13.4,12.2-21.2v-28.2c0-7.8-5.7-11-12.2-7.1c-10.5,6-20.6,12-31.1,17.9 c-7,3.9-12.3,13.4-12.3,21.2v28.2C724,593.6,729.3,596.7,736.3,592.8z M729.3,557.5c0-5.9,4.4-13.8,9.6-16.8l31.1-17.9 c0.9-0.7,2.2-1,2.6-1c0.4,0,0.4,0,0.9,0.1c0.4,0.3,0.9,1.5,0.9,3.5v28.2c0,6-4.4,13.7-9.6,16.7l-31.1,17.9c-1.7,1-3.1,1.1-3.5,0.8 c-0.4-0.3-0.9-1.4-0.9-3.4V557.5z"
}), React.createElement("path", {
  className: "st0",
  d: "M733.7,268.5l31.1-17.9c5.2-3,9.6-10.8,9.6-16.7v-28.3c0-2-0.4-3.2-0.9-3.5c-0.4-0.1-0.4-0.1-0.9-0.1 c-0.4,0-1.8,0.3-2.6,1l-31.1,17.9c-5.3,3-9.6,10.8-9.6,16.7v28.3c0,1.9,0.4,3.1,0.9,3.5C730.6,269.7,731.9,269.5,733.7,268.5z"
}), React.createElement("path", {
  className: "st1",
  d: "M730.6,279.8c2.6,0,5.7-0.8,8.3-2.4l31.1-17.9c7.9-4.8,14.4-16.1,14.4-25.7v-28.3c0-5.6-2.2-10.1-6.1-12.4 c-3.9-2.3-8.7-2-13.6,0.8L733.7,212c-8.3,4.8-14.9,16.1-14.9,25.6v28.2c0,5.6,2.2,10.1,6.1,12.4 C726.7,279.3,728.9,279.8,730.6,279.8z M724,237.7c0-7.8,5.2-17.3,12.3-21.2c10.5-6,20.6-12,31.1-17.9c6.6-3.9,12.2-0.8,12.2,7 v28.3c0,7.8-5.7,17.3-12.2,21.2L736.3,273c-7,3.9-12.3,0.7-12.3-7.1V237.7z"
}), React.createElement("path", {
  className: "st1",
  d: "M736.3,273l31.1-17.9c6.6-3.9,12.2-13.4,12.2-21.2v-28.3c0-7.8-5.7-10.9-12.2-7c-10.5,5.9-20.6,11.9-31.1,17.9 c-7,3.8-12.3,13.4-12.3,21.2v28.2C724,273.7,729.3,276.9,736.3,273z M729.3,237.7c0-5.9,4.4-13.7,9.6-16.7L770,203 c0.9-0.7,2.2-1,2.6-1c0.4,0,0.4,0,0.9,0.1c0.4,0.3,0.9,1.5,0.9,3.5v28.3c0,5.9-4.4,13.7-9.6,16.7l-31.1,17.9 c-1.7,1-3.1,1.2-3.5,0.9c-0.4-0.3-0.9-1.5-0.9-3.5V237.7z"
}), React.createElement("path", {
  className: "st0",
  d: "M733.7,481.7l31.1-17.9c5.2-3,9.6-10.8,9.6-16.7v-28.3c0-2-0.4-3.1-0.9-3.5c-0.4-0.1-0.4-0.1-0.9-0.1 c-0.4,0-1.8,0.3-2.6,1l-31.1,17.9c-5.3,3-9.6,10.8-9.6,16.8v28.3c0,2,0.4,3.2,0.9,3.4C730.6,482.9,731.9,482.7,733.7,481.7z"
}), React.createElement("path", {
  className: "st1",
  d: "M730.6,493c2.6,0,5.7-0.8,8.3-2.3l31.1-17.9c7.9-4.8,14.4-16.1,14.4-25.6v-28.3c0-5.6-2.2-10.1-6.1-12.4 c-3.9-2.2-8.7-1.9-13.6,0.9l-31.1,17.9c-8.3,4.8-14.9,16.1-14.9,25.6v28.2c0,5.6,2.2,10.1,6.1,12.4 C726.7,492.5,728.9,493,730.6,493z M724,450.9c0-7.8,5.2-17.3,12.3-21.2c10.5-6,20.6-12,31.1-17.9c6.6-3.9,12.2-0.7,12.2,7.1 c0,9.4,0,18.8,0,28.3c0,7.8-5.7,17.3-12.2,21.2c-10.5,6-20.6,12-31.1,17.9c-7,3.9-12.3,0.7-12.3-7.1C724,469.7,724,460.3,724,450.9 z"
}), React.createElement("path", {
  className: "st1",
  d: "M736.3,486.2c10.5-5.9,20.6-11.9,31.1-17.9c6.6-3.9,12.2-13.4,12.2-21.2c0-9.4,0-18.9,0-28.3 c0-7.8-5.7-10.9-12.2-7.1c-10.5,6-20.6,11.9-31.1,17.9c-7,3.9-12.3,13.4-12.3,21.2c0,9.4,0,18.8,0,28.2 C724,486.9,729.3,490.1,736.3,486.2z M729.3,450.9c0-5.9,4.4-13.8,9.6-16.8l31.1-17.9c0.9-0.8,2.2-1,2.6-1c0.4,0,0.4,0,0.9,0.1 c0.4,0.3,0.9,1.5,0.9,3.5v28.3c0,5.9-4.4,13.7-9.6,16.7l-31.1,17.9c-1.7,1-3.1,1.2-3.5,0.8c-0.4-0.3-0.9-1.5-0.9-3.4V450.9z"
}), React.createElement("path", {
  className: "st0",
  d: "M733.7,375.1l31.1-17.9c5.2-2.9,9.6-10.8,9.6-16.7v-28.3c0-2-0.4-3.2-0.9-3.5c-0.4-0.1-0.4-0.1-0.9-0.1 c-0.4,0-1.8,0.3-2.6,1l-31.1,17.9c-5.3,3-9.6,10.8-9.6,16.8v28.3c0,2,0.4,3.1,0.9,3.5C730.6,376.3,731.9,376.1,733.7,375.1z"
}), React.createElement("path", {
  className: "st1",
  d: "M730.6,386.4c2.6,0,5.7-0.8,8.3-2.3l31.1-17.9c7.9-4.8,14.4-16,14.4-25.6v-28.3c0-5.6-2.2-10.1-6.1-12.4 c-3.9-2.2-8.7-1.9-13.6,0.9l-31.1,17.9c-8.3,4.8-14.9,16.1-14.9,25.6v28.3c0,5.6,2.2,10.1,6.1,12.3 C726.7,385.9,728.9,386.4,730.6,386.4z M724,344.3c0-7.8,5.2-17.3,12.3-21.2c10.5-6,20.6-11.9,31.1-17.9c6.6-3.9,12.2-0.7,12.2,7 c0,9.4,0,18.8,0,28.3c0,7.8-5.7,17.3-12.2,21.2c-10.5,5.9-20.6,12-31.1,17.9c-7,3.9-12.3,0.7-12.3-7C724,363.1,724,353.7,724,344.3 z"
}), React.createElement("path", {
  className: "st1",
  d: "M736.3,379.6c10.5-5.9,20.6-11.9,31.1-17.9c6.6-3.9,12.2-13.4,12.2-21.2c0-9.5,0-18.9,0-28.3 c0-7.8-5.7-10.9-12.2-7c-10.5,5.9-20.6,11.9-31.1,17.9c-7,3.9-12.3,13.4-12.3,21.2c0,9.4,0,18.8,0,28.3 C724,380.3,729.3,383.5,736.3,379.6z M729.3,344.3c0-6,4.4-13.8,9.6-16.8l31.1-17.9c0.9-0.7,2.2-1,2.6-1c0.4,0,0.4,0.1,0.9,0.1 c0.4,0.3,0.9,1.5,0.9,3.5v28.3c0,5.9-4.4,13.8-9.6,16.7l-31.1,17.9c-1.7,1-3.1,1.2-3.5,0.9c-0.4-0.3-0.9-1.5-0.9-3.5V344.3z"
}), React.createElement("polygon", {
  className: "st0",
  points: "223.6,884.6 261.9,906.6 261.9,450.4 223.6,428.3  "
}), React.createElement("path", {
  className: "st1",
  d: "M215.9,891.9l48.6,28c-1.8-0.9-2.6-2.6-2.6-4.5v-3l-43.4-25V425.3l-2.6-1.5c-1.6-0.9-2.6-2.6-2.6-4.5v468.1 C213.3,889.4,214.3,891,215.9,891.9z"
}), React.createElement("path", {
  className: "st1",
  d: "M272.4,912.5l-5.3,3l-5.2-3v3c0,1.8,0.9,3.5,2.6,4.5c0.9,0.4,1.7,0.7,2.6,0.7c0.9,0,1.8-0.3,2.6-0.7 c1.3-0.9,2.6-2.6,2.6-4.5V912.5z"
}), React.createElement("path", {
  className: "st1",
  d: "M272.4,450.4L272.4,450.4l-2.6,1.5c-0.9,0.4-1.7,0.7-2.6,0.7v463l5.3-3v-5.9V450.4z"
}), React.createElement("polygon", {
  className: "st1",
  points: "223.6,884.6 223.6,428.3 261.9,450.4 261.9,450.4 218.5,425.3 218.5,887.5 261.9,912.5 261.9,906.6  "
}), React.createElement("path", {
  className: "st1",
  d: "M267.1,452.6c-0.9,0-1.7-0.3-2.6-0.7l-2.6-1.5v0v456.2v5.9l5.2,3V452.6z"
}), React.createElement("path", {
  className: "st0",
  d: "M282,432.9l46.9-27.1l-5.7-3.3c-1.7-0.9-2.6-2.6-2.6-4.5c0-1.8,0.9-3.5,2.6-4.4l27.4-15.8l-24.8-14.3l-96.9,56 l30.3,17.5l8,4.6L282,432.9z"
}), React.createElement("polygon", {
  className: "st0",
  points: "339.3,399.7 363.9,385.5 360.9,383.7 336.3,398  "
}), React.createElement("path", {
  className: "st0",
  d: "M320.5,398c0,1.9,0.9,3.6,2.6,4.5l5.7,3.3l5.2-3l-8.2-4.8l29.9-17.3l-5.1-3l-27.4,15.8 C321.4,394.5,320.5,396.2,320.5,398z"
}), React.createElement("polygon", {
  className: "st0",
  points: "334,402.7 339.3,399.7 336.3,398 360.9,383.7 355.7,380.7 325.8,398  "
}), React.createElement("polygon", {
  className: "st0",
  points: "267.1,441.5 267.1,441.5 282,432.9  "
}), React.createElement("polygon", {
  className: "st0",
  points: "259.2,436.9 267.1,441.5 267.1,441.5  "
}), React.createElement("polygon", {
  className: "st0",
  points: "267.1,441.5 267.1,441.5 267.1,441.5 267.1,441.5  "
}), React.createElement("path", {
  className: "st1",
  d: "M221,415l2.6,1.5l102.2-59l30,17.3l5.1-3L328.4,353c-1.8-0.9-3.5-0.9-5.3,0L215.9,415 C217.5,414,219.4,414,221,415z"
}), React.createElement("path", {
  className: "st1",
  d: "M371.7,381c1.8-0.9,3.5-0.9,5.3,0l-5.7-3.3l-5.1,3l3.1,1.8L371.7,381z"
}), React.createElement("polygon", {
  className: "st1",
  points: "360.9,377.7 366,374.7 360.9,371.8 355.8,374.7  "
}), React.createElement("polygon", {
  className: "st1",
  points: "371.3,377.7 366,374.7 360.9,377.7 366.1,380.7  "
}), React.createElement("polygon", {
  className: "st1",
  points: "297.6,435.8 339.2,411.7 339.2,411.7  "
}), React.createElement("polygon", {
  className: "st1",
  points: "369.1,394.5 369.1,394.4 349.6,405.7 349.6,405.7  "
}), React.createElement("polygon", {
  className: "st1",
  points: "344.4,408.7 339.2,411.7 339.2,411.7 344.4,408.7  "
}), React.createElement("polygon", {
  className: "st1",
  points: "349.6,405.7 344.4,408.7 344.4,408.7 349.6,405.7  "
}), React.createElement("path", {
  className: "st1",
  d: "M374.4,391.4l2.6-1.5c1.8-0.9,2.6-2.6,2.6-4.5c0-1.8-0.9-3.5-2.6-4.4c-1.7-0.9-3.5-0.9-5.3,0l-2.5,1.5l5.1,3 V391.4z"
}), React.createElement("path", {
  className: "st1",
  d: "M339.2,411.7l-5.1-3l-62.5,36.1c0.5,0.8,0.8,1.7,0.8,2.6v3l25.2-14.6L339.2,411.7z"
}), React.createElement("polygon", {
  className: "st1",
  points: "369.1,394.4 369.1,394.5 374.4,391.4 374.4,385.5 344.5,402.7 349.6,405.7  "
}), React.createElement("polygon", {
  className: "st1",
  points: "339.2,405.7 334.1,408.7 339.2,411.7 344.4,408.7  "
}), React.createElement("polygon", {
  className: "st1",
  points: "349.6,405.7 344.5,402.7 339.2,405.7 344.4,408.7  "
}), React.createElement("path", {
  className: "st1",
  d: "M215.9,423.8l2.6,1.5v-6l5.1-2.9L221,415c-1.6-0.9-3.5-0.9-5.1,0c-1.6,0.9-2.6,2.6-2.6,4.4 C213.3,421.2,214.3,423,215.9,423.8z"
}), React.createElement("path", {
  className: "st1",
  d: "M272.4,450.4v-3c0-0.9-0.3-1.8-0.8-2.6l-4.4,2.6v5.2c0.9,0,1.8-0.3,2.6-0.7L272.4,450.4z"
}), React.createElement("path", {
  className: "st1",
  d: "M261.9,447.4c0-0.9,0.2-1.8,0.7-2.6l-44.1-25.4v6l43.4,25V447.4z"
}), React.createElement("path", {
  className: "st1",
  d: "M262.6,444.8c-0.5,0.8-0.7,1.7-0.7,2.6v3l2.6,1.5c0.9,0.4,1.7,0.7,2.6,0.7v-5.2L262.6,444.8z"
}), React.createElement("polygon", {
  className: "st1",
  points: "228.8,419.4 325.8,363.4 350.5,377.7 355.8,374.7 325.8,357.4 223.6,416.4 259.2,436.9  "
}), React.createElement("polygon", {
  className: "st1",
  points: "328.9,405.7 282,432.9 328.9,405.8  "
}), React.createElement("polygon", {
  className: "st1",
  points: "339.3,399.7 339.3,399.7 369.2,382.5 366.1,380.7 360.9,383.7 363.9,385.5  "
}), React.createElement("polygon", {
  className: "st1",
  points: "334.1,402.8 334,402.7 328.9,405.7 328.9,405.8  "
}), React.createElement("polygon", {
  className: "st1",
  points: "355.7,380.7 360.9,377.7 355.8,374.7 350.5,377.7  "
}), React.createElement("polygon", {
  className: "st1",
  points: "360.9,383.7 366.1,380.7 360.9,377.7 355.7,380.7  "
}), React.createElement("polygon", {
  className: "st1",
  points: "339.3,399.7 339.3,399.7 334,402.7 334.1,402.8  "
}), React.createElement("path", {
  className: "st1",
  d: "M328.9,405.8L282,432.9l-14.8,8.6l2.6,1.5c0.7,0.5,1.3,1.1,1.8,1.9l62.5-36.1L328.9,405.8z"
}), React.createElement("polygon", {
  className: "st1",
  points: "374.4,385.5 369.2,382.5 339.3,399.7 344.5,402.7  "
}), React.createElement("polygon", {
  className: "st1",
  points: "334.1,402.8 328.9,405.8 334.1,408.7 339.2,405.7  "
}), React.createElement("polygon", {
  className: "st1",
  points: "339.2,405.7 344.5,402.7 339.3,399.7 334.1,402.8  "
}), React.createElement("path", {
  className: "st1",
  d: "M264.5,443l2.6-1.5l-7.9-4.6l-35.6-20.4l-5.1,2.9l44.1,25.4C263,444.1,263.7,443.4,264.5,443z"
}), React.createElement("path", {
  className: "st1",
  d: "M271.6,444.9c-0.5-0.8-1.1-1.4-1.8-1.9l-2.6-1.5l0,0l0,0l-2.6,1.5c-0.9,0.4-1.5,1.1-1.9,1.8l4.5,2.6 L271.6,444.9z"
}), React.createElement("path", {
  className: "st0",
  d: "M341.5,451.1c-0.9,0-1.8,0.3-3.1,1l-31.1,17.9c-5.2,3-9.6,10.8-9.6,16.8v28.2c0,2,0.4,3.2,0.9,3.5 c0.4,0.3,1.7,0.1,3.5-0.9l31.1-17.9c5.3-3,9.6-10.8,9.6-16.7v-28.3c0-2-0.4-3.2-0.9-3.5C342,451.1,341.5,451.1,341.5,451.1z"
}), React.createElement("path", {
  className: "st1",
  d: "M333.2,443.1L302.2,461c-8.3,4.8-14.4,16.1-14.4,25.7v28.2c0,5.6,2.2,10.1,6.1,12.4c1.7,1,3.5,1.5,5.7,1.5 c2.6,0,5.2-0.8,7.9-2.4l31.1-17.9c8.3-4.8,14.9-16.1,14.9-25.7v-28.3c0-5.6-2.2-10.1-6.1-12.4C343.3,440,338,440.3,333.2,443.1z  M348.1,482.9c0,7.8-5.2,17.3-12.3,21.2L304.8,522c-6.6,3.9-12.3,0.8-12.3-7.1v-28.2c0-7.8,5.7-17.3,12.3-21.2 c10.5-5.9,20.6-11.9,31.1-17.9c7-3.9,12.3-0.7,12.3,7V482.9z"
}), React.createElement("path", {
  className: "st1",
  d: "M335.8,447.6c-10.5,6-20.6,12-31.1,17.9c-6.6,3.9-12.3,13.4-12.3,21.2v28.2c0,7.8,5.7,11,12.3,7.1l31.1-17.9 c7-3.9,12.3-13.4,12.3-21.2v-28.3C348.1,446.9,342.9,443.7,335.8,447.6z M342.9,482.9c0,5.9-4.4,13.7-9.6,16.7l-31.1,17.9 c-1.8,1-3.1,1.1-3.5,0.9c-0.4-0.3-0.9-1.5-0.9-3.5v-28.2c0-6,4.4-13.8,9.6-16.8l31.1-17.9c1.3-0.7,2.2-1,3.1-1c0,0,0.4,0,0.4,0.1 c0.4,0.3,0.9,1.5,0.9,3.5V482.9z"
}), React.createElement("path", {
  className: "st0",
  d: "M341.5,770.9c-0.9,0-1.8,0.3-3.1,1l-31.1,17.9c-5.2,3-9.6,10.8-9.6,16.7v28.3c0,2,0.4,3.2,0.9,3.4 c0.4,0.3,1.7,0.2,3.5-0.8l31.1-17.9c5.3-3,9.6-10.8,9.6-16.7v-28.3c0-2-0.4-3.2-0.9-3.5C342,770.9,341.5,770.9,341.5,770.9z"
}), React.createElement("path", {
  className: "st1",
  d: "M333.2,763l-31.1,17.9c-8.3,4.8-14.4,16.1-14.4,25.6v28.3c0,5.6,2.2,10.1,6.1,12.4c1.7,1,3.5,1.5,5.7,1.5 c2.6,0,5.2-0.8,7.9-2.4l31.1-17.9c8.3-4.8,14.9-16.1,14.9-25.6v-28.3c0-5.6-2.2-10.1-6.1-12.4C343.3,759.9,338,760.2,333.2,763z  M348.1,802.7c0,7.8-5.2,17.3-12.3,21.2l-31.1,17.9c-6.6,3.9-12.3,0.7-12.3-7v-28.3c0-7.8,5.7-17.3,12.3-21.2 c10.5-6,20.6-11.9,31.1-17.9c7-3.9,12.3-0.7,12.3,7V802.7z"
}), React.createElement("path", {
  className: "st1",
  d: "M335.8,767.4c-10.5,6-20.6,11.9-31.1,17.9c-6.6,3.9-12.3,13.4-12.3,21.2v28.3c0,7.8,5.7,10.9,12.3,7l31.1-17.9 c7-3.9,12.3-13.4,12.3-21.2v-28.3C348.1,766.7,342.9,763.5,335.8,767.4z M342.9,802.7c0,5.9-4.4,13.7-9.6,16.7l-31.1,17.9 c-1.8,1-3.1,1.2-3.5,0.8c-0.4-0.3-0.9-1.4-0.9-3.4v-28.3c0-6,4.4-13.7,9.6-16.7l31.1-17.9c1.3-0.7,2.2-1,3.1-1c0,0,0.4,0.1,0.4,0.1 c0.4,0.3,0.9,1.5,0.9,3.5V802.7z"
}), React.createElement("path", {
  className: "st0",
  d: "M341.5,664.3c-0.9,0-1.8,0.3-3.1,1l-31.1,17.9c-5.2,3-9.6,10.8-9.6,16.8v28.2c0,2,0.4,3.2,0.9,3.5 c0.9,0.3,2.2,0.2,3.5-0.8l31.1-17.9c5.3-3,9.6-10.8,9.6-16.8v-28.2c0-2-0.4-3.2-0.9-3.5C342,664.3,341.5,664.3,341.5,664.3z"
}), React.createElement("path", {
  className: "st1",
  d: "M333.2,656.4l-31.1,17.9c-8.3,4.8-14.4,16.1-14.4,25.6v28.2c0,5.6,2.2,10.1,6.1,12.4c1.7,1,3.5,1.5,5.7,1.5 c2.6,0,5.2-0.8,7.9-2.4l31.1-17.9c8.3-4.8,14.9-16,14.9-25.6v-28.2c0-5.6-2.2-10.1-6.1-12.4C343.3,653.3,338,653.6,333.2,656.4z  M348.1,696.1c0,7.8-5.2,17.3-12.3,21.2c-10.5,5.9-20.6,11.9-31.1,17.9c-6.6,3.9-12.3,0.7-12.3-7.1c0-9.4,0-18.8,0-28.2 c0-7.8,5.7-17.3,12.3-21.2c10.5-6,20.6-11.9,31.1-17.9c7-3.9,12.3-0.7,12.3,7.1C348.1,677.3,348.1,686.7,348.1,696.1z"
}), React.createElement("path", {
  className: "st1",
  d: "M335.8,660.8c-10.5,6-20.6,11.9-31.1,17.9c-6.6,3.9-12.3,13.4-12.3,21.2c0,9.4,0,18.8,0,28.2 c0,7.8,5.7,11,12.3,7.1c10.5-6,20.6-12,31.1-17.9c7-3.9,12.3-13.4,12.3-21.2c0-9.4,0-18.8,0-28.2 C348.1,660.1,342.9,656.9,335.8,660.8z M342.9,696.1c0,6-4.4,13.8-9.6,16.8l-31.1,17.9c-1.3,1-2.6,1.1-3.5,0.8 c-0.4-0.3-0.9-1.5-0.9-3.5v-28.2c0-5.9,4.4-13.8,9.6-16.8l31.1-17.9c1.3-0.7,2.2-1,3.1-1c0,0,0.4,0,0.4,0.1 c0.4,0.3,0.9,1.5,0.9,3.5V696.1z"
}), React.createElement("path", {
  className: "st0",
  d: "M341.5,557.7c-0.9,0-1.8,0.3-3.1,1l-31.1,17.9c-5.2,3-9.6,10.8-9.6,16.7v28.3c0,1.9,0.4,3.1,0.9,3.4 c0.9,0.3,2.2,0.2,3.5-0.8l31.1-17.9c5.3-3,9.6-10.8,9.6-16.7v-28.3c0-2-0.4-3.2-0.9-3.5L341.5,557.7z"
}), React.createElement("path", {
  className: "st1",
  d: "M333.2,549.7l-31.1,17.9c-8.3,4.8-14.4,16-14.4,25.6v28.3c0,5.6,2.2,10.1,6.1,12.4c1.7,1,3.5,1.5,5.7,1.5 c2.6,0,5.2-0.8,7.9-2.4l31.1-17.9c8.3-4.8,14.9-16,14.9-25.6v-28.3c0-5.6-2.2-10.1-6.1-12.4C343.3,546.6,338,546.9,333.2,549.7z  M348.1,589.5c0,7.8-5.2,17.3-12.3,21.1c-10.5,6-20.6,12-31.1,17.9c-6.6,3.9-12.3,0.7-12.3-7.1c0-9.4,0-18.8,0-28.3 c0-7.8,5.7-17.3,12.3-21.2c10.5-5.9,20.6-11.9,31.1-17.9c7-3.9,12.3-0.7,12.3,7.1C348.1,570.7,348.1,580.1,348.1,589.5z"
}), React.createElement("path", {
  className: "st1",
  d: "M335.8,554.2c-10.5,6-20.6,12-31.1,17.9c-6.6,3.9-12.3,13.4-12.3,21.2c0,9.4,0,18.8,0,28.3 c0,7.8,5.7,11,12.3,7.1c10.5-6,20.6-11.9,31.1-17.9c7-3.8,12.3-13.3,12.3-21.1c0-9.4,0-18.9,0-28.3 C348.1,553.5,342.9,550.3,335.8,554.2z M342.9,589.5c0,5.9-4.4,13.7-9.6,16.7l-31.1,17.9c-1.3,1-2.6,1.2-3.5,0.8 c-0.4-0.3-0.9-1.5-0.9-3.4v-28.3c0-5.9,4.4-13.7,9.6-16.7l31.1-17.9c1.3-0.7,2.2-1,3.1-1l0.4,0.1c0.4,0.3,0.9,1.5,0.9,3.5V589.5z"
}));

var SvgVideoOldIcon = function SvgVideoOldIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Livello_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1024 1024",
    style: {
      enableBackground: "new 0 0 1024 1024"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgVideoOldIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/VideoOld_Icon.d9ac2f12.svg";
export { ForwardRef as ReactComponent };